import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

const ftlabsTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#2962FF"
    },
    secondary: green,
  },
  status: {
    danger: 'orange',
  },
  typography:{
    h4: {
      fontFamily: "Grand Hotel",     
      fontSize: "60px",
      textAlign: "center",
      color: "#08131f",
      letterSpacing: "0.02em",
      ['@media screen and (max-width: 600px)']:{ // eslint-disable-line no-useless-computed-key
        fontSize:'40px'
    }
    },
    subtitle1:{
      color: "#5e6977"
    },
    headline:{
      color: "#43484d"
    }
  }
});

export default ftlabsTheme;